<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
        {{ $route.query.id ? "编辑" : "新增" }}人员详细信息
      </div>

    </div>
    <div class="ml20  f18 blue cursor">
      <i class="el-icon-back" @click="$router.back()">返回</i>
      <div class="flr" style="float:right"></div>
    </div>
    <el-form ref="form" :model="form" class="mt20" label-width="110px">
      <el-row :gutter="20">

        <el-col :span="6">
          <el-form-item :rules="[{required:true,message:'请输入姓名',trigger: 'blur'}]" label="姓名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :rules="[{required:true,message:'请输入电话',trigger: 'blur'}]" label="电话" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所在区域" prop="user_phone">
            <el-select v-model="form.tower" filterable placeholder="一级分区" @change="changetower($event, true)">
              <el-option v-for="(item, index) in units" :key="item.tower" :label="item.tower" :value="item.tower">{{ item.tower }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="" prop="user_phone">
            <el-select v-model="form.tier" filterable placeholder="二级分区">
              <el-option v-for="item in select2" :key="item" :label="item" :value="item">{{ item }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="固定职责" prop="login_pass">
            <el-select v-model="form.organi" @change="changeRespon">
              <el-option v-for="(item, index) in roles" :key="item.zuzhi_xuhao" :label="item.zuzhi_name" :value="item.zuzhi_xuhao"></el-option>
            </el-select>
            <!-- <el-select v-if="form.respon == 2" v-model="form.organitwo" class="mt10">
              <el-option v-for="(item, index) in roles" :key="item.zuzhi_xuhao" :label="item.zuzhi_name" :value="item.zuzhi_xuhao"></el-option>
            </el-select>  -->
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="所在部门" prop="login_pass">
            <el-input v-model="form.department"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="性别" prop="login_pass">
            <!-- <el-input v-model=" sex"></el-input> -->
            <el-select v-model="form.sex">
              <el-option :value="1" label="男"></el-option>
              <el-option :value="2" label="女"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="btn-box center">
        <el-button type="primary" @click="onSubmit" v-hasPermi="['drillplan:planUser:addAndUpdate']">保存</el-button>
        <!-- <el-button type="success" @click="ImportPersonnel">导入</el-button> -->
      </div>
    </el-form>
  </div>
</template>

<script>
import {addUser} from "../../api/user";
import t from "../../utils/ezuikit";

export default {
  data() {
    return {
      form: {
        name: "", // 姓名
        phone: "", // 电话
        sex: 1,
        department: "",
        respon: 1, // 介个职责
        tower: "", // 楼
        tier: "", // 层
        organi: "", // 第一职责
        organitwo: "",
        companyNum: this.$local.get("company").c_company_num,
      },
      roles: [],
      select2: [],
      units: [],
    };
  },
  async created() {
    // 组别
    await this.$post("/drill/grouplist").then((res) => {
      this.roles = res.data;
      this.roles.unshift({note_id: 0, zuzhi_name: "无", zuzhi_xuhao: 0});
    });
    // 区域
    await this.$get(`/drillplan/planJianzhu/planArea/${this.form.companyNum}`).then((res) => {
      this.units = res.data;
    });
    if (this.$route.query.id) {
      this.$get(`/drillplan/planUser/${this.$route.query.id}`).then((res) => {
        this.form = res.data;
        this.changetower(this.form.tower);
      });
    }
  },
  watch: {},
  methods: {
    changetower(val, istr) {
      if (istr) {
        this.form.tier = "";
      }
      this.units.map((item, index) => {
        if (item.tower === val) {
          this.select2 = item.tierList;
        }
      });
    },
    changeRespon(val) {
      if (val == "") this.form.respon = 2;
      else this.form.respon = val;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.status = 0;
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    save() {
      let loading = this.$loading({background: "rgba(0, 0, 0, 0.6)"});
      // this.$route.query.id ? "/drillplan/planUser/edit" : "/drillplan/planUser/add"
      let api = "/drillplan/planUser/addAndUpdate";
      this.$post(api, this.form)
          .then((res) => {
            this.form = res.data;
            // log(res, 11111);
            // this.$message.success("保存成功");
            this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
            this.$router.back();
            loading.close();
          })
          .catch((err) => {
            loading.close();
          });
    },
  },
};
</script>

<style scoped></style>
